import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'vex-weight-history',
  templateUrl: './weight-history.component.html',
  styleUrls: ['./weight-history.component.scss']
})
export class WeightHistoryComponent implements OnInit {
  @Input() exerciseId;
  exercise;
  exercises;
  loader: boolean = false;
  elementPlaceholder = Array(3);

  constructor(private restService: RestService, public guiService: GuiService, public translate: TranslateService, private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.exerciseId = data.exerciseId;
  }

  ngOnInit(): void {
    this.getExercises();
  }

  closeModal() {
    this.dialogRef.close();
  }

   getExercises() {
    this.loader = true;
    this.restService.postService('node', '/user-exercise-tracker', { userId: this.guiService.userLogged.user.id }).subscribe((ris) => {
      this.mergeExercises(ris);
    })
  }

  mergeExercises(ris) {
      const mergedExercises = [];
      if (ris.length > 0) {
        ris.forEach(exercise => {
          let foundIndex = mergedExercises.findIndex(x => x.exerciseId === exercise.exerciseId);
          if (foundIndex > -1) {
            mergedExercises[foundIndex].datas.push(
              {
                "unit": exercise.unit,
                "reps": exercise.reps,
                "seconds": exercise.seconds,
                "registerDate": exercise.registerDate,
                "weight": exercise.weight,
                "workoutId": exercise.workoutId,
                "i18nNameWorkout": exercise.i18nNameWorkout,
                "phaseName": exercise.phaseName
              }
            )
          } else {
            let element = {
              "exerciseId": exercise.exerciseId,
              "exerciseName": exercise.exerciseName,
              "datas": [
                {
                  "unit": exercise.unit,
                  "reps": exercise.reps,
                  "seconds": exercise.seconds,
                  "registerDate": exercise.registerDate,
                  "weight": exercise.weight,
                  "workoutId": exercise.workoutId,
                  "i18nNameWorkout": exercise.i18nNameWorkout,
                  "phaseName": exercise.phaseName
                }
              ]
            }
            mergedExercises.push(element);
          }
        });
      }

      mergedExercises.forEach(ex => {
        ex.datas.sort((a, b) => moment(b.registerDate).diff(moment(a.registerDate)));
      });

      this.exercises = mergedExercises;
      const exFound = this.exercises.find(x => x.exerciseId === this.exerciseId);
      console.debug(this.exerciseId)
      exFound ? this.exercise = exFound : null;
      this.loader = false;
    }

  convertToMMSS(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
    const formattedSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds.toString();

    return `${formattedMinutes}:${formattedSeconds}`;
  }

}
